var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividualUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "19px",
    viewBox: "0 0 17 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B18EEBF-F2D5-48F3-A854-D77E21E5B6A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Duplicates-Provided--Scroll",
    transform: "translate(-342.000000, -406.000000)",
    fill: "#08425C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(325.500000, 352.569767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(17.373542, 54.230233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91015625,0 C5.29316016,0 3.1640625,2.12909766 3.1640625,4.74609375 C3.1640625,7.36308984 5.29316016,9.4921875 7.91015625,9.4921875 C10.5271523,9.4921875 12.65625,7.36308984 12.65625,4.74609375 C12.65625,2.12909766 10.5271523,0 7.91015625,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8152109,12.592793 C12.5158359,11.2734492 10.7932852,10.546875 8.96484375,10.546875 L6.85546875,10.546875 C5.0270625,10.546875 3.30447656,11.2734492 2.00510156,12.592793 C0.712089844,13.905668 0,15.6386602 0,17.4726562 C0,17.7638906 0.236109375,18 0.52734375,18 L15.2929688,18 C15.5842031,18 15.8203125,17.7638906 15.8203125,17.4726562 C15.8203125,15.6386602 15.1082227,13.905668 13.8152109,12.592793 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualUser);
export default __webpack_public_path__ + "static/media/individual-user.0d2ee0acabdc86ecd44cf807be316c9e.svg";
export { ForwardRef as ReactComponent };